import { $t } from '@/langs/i18n'

export default [
  {
    path: '/',
    name: 'home',
    meta: {
      layout: {
        hideNativeBar: true,
        isImmersive: true, //
        titleBar: {
          isHidden: false, // 前端标题栏是否出现
          center: '首页' // 前端标题栏title
        },
        statusBar: {
          isHidden: false // 前端状态栏是否隐藏
        }
      }
    },
    component: () => import('../views/HomeView.vue')
  },
  {
    path: '/recruit',
    name: 'recruit',
    component: () => import('../views/RecruitView/RecruitView.vue'),
    children: [
      {
        path: 'center',
        name: 'recruitCenter',
        meta: {
          layout: {
            hideNativeBar: true,
            titleBar: {
              center: $t('kiti_base_recruit-center_route_title'),
              isHidden: false
            },
            statusBar: {
              isHidden: false
            }
          }
        },
        component: () => import('../views/RecruitView/CenterView.vue')
      },
      {
        path: 'anchorCenter',
        name: 'anchorRecruitCenter',
        meta: {
          layout: {
            hideNativeBar: true,
            titleBar: {
              center: $t('kiti_base_recruit-center_route_title'),
              isHidden: false
            },
            statusBar: {
              isHidden: false
            }
          }
        },
        component: () => import('../views/RecruitView/AnchorRecruitView.vue')
      },
      {
        path: 'benefit',
        name: 'recruitBenefit',
        meta: {
          layout: {
            hideNativeBar: false,
            isImmersive: true,
            titleBar: {
              center: $t('kiti_base_recruit-benefit_claim_now'),
              isHidden: true,
              isTransparent: true
            },
            statusBar: {
              isHidden: true
            }
          }
        },
        component: () => import('../views/RecruitView/BenefitView.vue')
      },
      {
        path: 'invite',
        name: 'recruitInvite',
        meta: {
          layout: {
            titleBar: {
              center: $t('kiti_base_recruit-invite_route_title')
            }
          }
        },
        component: () => import('../views/RecruitView/InviteView.vue')
      },
      {
        path: 'recallInvite',
        name: 'recallInvite',
        meta: {
          layout: {
            titleBar: {
              center: $t('kiti_base_recruit-invite_route_title')
            }
          }
        },
        component: () => import('../views/RecruitView/RecallInviteView.vue')
      },
      {
        path: 'family',
        name: 'FamilyInvite',
        meta: {
          layout: {
            titleBar: {
              center: $t('kiti_base_recruit-family_route_title')
            }
          }
        },
        component: () => import('../views/RecruitView/FamilyInviteView.vue')
      },
      {
        path: 'familyMillion',
        name: 'FamilyMillionInvite',
        meta: {
          layout: {
            titleBar: {
              center: $t('kiti_base_recruit-family-million_route_title')
            }
          }
        },
        component: () => import('../views/RecruitView/FamilyMillionInviteView.vue')
      },
      {
        path: 'gameCoin100k',
        name: 'GameCoin100kInvite',
        meta: {
          layout: {
            titleBar: {
              center: $t('kiti_base_recruit-invite_route_title')
            }
          }
        },
        component: () => import('../views/RecruitView/GameCoin100kInviteView.vue')
      },
      {
        path: 'rules',
        name: 'recruitRules',
        meta: {
          layout: {
            hideNativeBar: true,
            titleBar: {
              center: $t('kiti_base_recruit-rules_route_title'),
              isHidden: false
            },
            statusBar: {
              isHidden: false
            }
          }
        },
        component: () => import('../views/RecruitView/RulesView.vue')
      },
      {
        path: 'inviteCode',
        name: 'InviteCode',
        meta: {
          layout: {
            hideNativeBar: true,
            titleBar: {
              isHidden: true
            },
            statusBar: {
              isHidden: true
            }
          }
        },
        component: () => import('../views/RecruitView/InviteCode.vue')
      },
      {
        path: 'receivedModalView',
        name: 'ReceivedModalView',
        meta: {
          layout: {
            hideNativeBar: true,
            titleBar: {
              isHidden: true
            },
            statusBar: {
              isHidden: true
            }
          }
        },
        component: () => import('../views/RecruitView/ReceivedModalView.vue')
      },
      {
        path: 'recallModalView',
        name: 'RecallModalView',
        meta: {
          layout: {
            hideNativeBar: true,
            titleBar: {
              isHidden: true
            },
            statusBar: {
              isHidden: true
            }
          }
        },
        component: () => import('../views/RecruitView/RecallModalView.vue')
      },
      {
        path: 'gameModalView',
        name: 'GameModalView',
        meta: {
          layout: {
            hideNativeBar: true,
            titleBar: {
              isHidden: true
            },
            statusBar: {
              isHidden: true
            }
          }
        },
        component: () => import('../views/RecruitView/GameModalView.vue')
      },
      {
        path: 'luckyWheelModalView',
        name: 'LuckyWheelModalView',
        meta: {
          layout: {
            hideNativeBar: true,
            titleBar: {
              isHidden: true
            },
            statusBar: {
              isHidden: true
            }
          }
        },
        component: () => import('../views/RecruitView/LuckyWheelModalView.vue')
      },
      {
        path: 'rewardViewConfirm',
        name: 'RewardViewConfirm',
        meta: {
          layout: {
            hideNativeBar: true,
            titleBar: {
              isHidden: true
            },
            statusBar: {
              isHidden: true
            }
          }
        },
        component: () => import('../views/RecruitView/ConfirmRewardView.vue')
      },

      {
        path: 'inviteFriend',
        name: 'InviteFriend',
        meta: {
          layout: {
            hideNativeBar: true,
            titleBar: {
              isHidden: true
            },
            statusBar: {
              isHidden: true
            }
          }
        },
        component: () => import('../views/RecruitView/InviteFriend.vue')
      },

      {
        path: 'bindInviter',
        name: 'BindInviter',
        meta: {
          layout: {
            hideNativeBar: true,
            isImmersive: true,
            theme: 'dark',
            titleBar: {
              center: $t('kiti_base_recruit-rules_change_8'),
              isHidden: false,
              isTransparent: true,
              scrollBgColor: 'no'
            },
            statusBar: {
              isHidden: false
            }
          }
        },
        component: () => import('../views/RecruitView/BindInviter/index.vue')
      },

      {
        path: 'personalInvite',
        name: 'personalInvite',
        meta: {
          layout: {
            titleBar: {
              center: $t('kiti_base_recruit-invite_route_title')
            }
          }
        },
        component: () => import('../views/RecruitView/PersonalInvite.vue')
      }
    ]
  },
  {
    path: '/about',
    meta: {
      layout: {
        titleBar: {
          center: $t('kiti_base_title')
        }
      }
    },
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (About.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/AboutView.vue')
  },
  {
    path: '/test',
    name: 'test',

    component: () => import('../views/TestView/TestView.vue'),
    children: [
      {
        path: 'bridge',
        component: () => import('../views/TestView/BridgeView/BridgeView.vue'),
        children: [
          {
            path: 'bridge-debug',
            name: 'bridgeDebug',
            component: () => import('../views/TestView/BridgeView/BridgeDebug.vue')
          },
          {
            path: 'immersive',
            name: 'immersive',
            meta: {
              layout: {
                hideNativeBar: true,
                isImmersive: true,
                theme: 'dark',
                statusBar: {
                  isHidden: false
                },
                titleBar: {
                  isHidden: false,
                  isTransparent: true,
                  center: '沉浸式测试页',
                  scrollBgColor: '#003a7d'
                }
              }
            },
            component: () => import('../views/TestView/BridgeView/ImmersiveView.vue')
          },
          {
            path: 'noimmersive',
            name: 'noimmersive',
            meta: {
              layout: {
                isImmersive: false,
                theme: 'auto',
                titleBar: {
                  center: '非沉浸式',
                  isTransparent: true,
                  isHidden: false
                }
              }
            },
            component: () => import('../views/TestView/BridgeView/NoImmersiveView.vue')
          },
          {
            path: 'noimmersive-light',
            name: 'noimmersive-light',
            meta: {
              layout: {
                isImmersive: false,
                theme: 'light',
                titleBar: {
                  center: '非沉浸式-白天',
                  isTransparent: true,
                  isHidden: false
                }
              }
            },
            component: () => import('../views/TestView/BridgeView/NoImmersiveView.vue')
          },
          {
            path: 'noimmersive-dark',
            name: 'noimmersive-dark',
            meta: {
              layout: {
                isImmersive: false,
                theme: 'dark',
                titleBar: {
                  center: '非沉浸式-暗夜',
                  isTransparent: true,
                  isHidden: false
                }
              }
            },
            component: () => import('../views/TestView/BridgeView/NoImmersiveView.vue')
          }
        ]
      }
    ]
  }
]
